import AOS from 'aos';

class Tabs {
  #activeTab = null;
  #tabElement = null;
  #tabDesktopForm = null;
  #tabMobileForm = null;
  #tabElements = null;
  #tabSelected = null;

  constructor(tabElement) {
    this.#tabElement = tabElement;
    this.#tabDesktopForm = this.#tabElement.querySelector('[data-tabs-desktop-form]');
    this.#tabElements = this.#tabElement.querySelectorAll('[data-tab]');
    this.#tabMobileForm = this.#tabElement.querySelector('[data-tabs-form]');
    this.#tabSelected = this.#tabElement.querySelector('[data-tab-selected]');

    if(this.#tabElements.length > 0) {
      this.#activeTab = this.#tabElements[0]?.dataset?.tab || this.#tabElements[0].dataset.tab;
    } else {
      this.#activeTab = null;
    }
  }

  init() {
    if(this.#tabElements.length === 0) {
      return;
    }

    this.#tabElements.forEach((tab) => {
      tab.classList.add('visually-hidden');
    });

    this.#tabElement.querySelector(`[data-tab="${this.#activeTab}"]`).classList.remove('visually-hidden');

    this.#tabDesktopForm.addEventListener('change', (e) => {
      e.preventDefault();
      const name = this.#tabDesktopForm.querySelector(`label[for="${e.target.id}"]`).textContent;
      this.changeTab(e.target.value, name);
    });

    if (this.#tabMobileForm) {
      this.#tabMobileForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const value = this.#tabMobileForm.querySelector('input:checked').value;
        const name = this.#tabMobileForm.querySelector('input:checked + label').textContent;
        this.changeTab(value, name);
      });
    }

    setTimeout(() => {
      const value = this.#tabDesktopForm.querySelector('input:checked').value;
      const name = this.#tabDesktopForm.querySelector('input:checked + label').textContent;
      this.changeTab(value, name);
    }, 100);
  }

  changeTab = (value, name) => {
    const previousTab = this.#tabElement.querySelector(`[data-tab="${this.#activeTab}"]`);
    const newTab = this.#tabElement.querySelector(`[data-tab="${value}"]`);

    previousTab.classList.add('visually-hidden');

    newTab.classList.remove('visually-hidden');

    AOS.refresh();

    this.#activeTab = value;

    if (this.#tabSelected) {
      this.#tabSelected.textContent = name;
    }

    this.#tabDesktopForm.querySelector(`input[value="${value}"]`).checked = true;
    if (this.#tabMobileForm) {
      this.#tabMobileForm.querySelector(`input[value="${value}"]`).checked = true;
    }
  };
}

const initTabs = () => {
  const tabs = document.querySelectorAll('[data-tabs]');
  if (tabs.length) {
    tabs.forEach((tab) => {
      const tabElement = new Tabs(tab);
      tabElement.init();
    });
  }
};

export { initTabs };
